export default "__VITE_ASSET__Cjz79Odd__"